/**
 * CS: Cart Summary — discount removal + details open-state restore.
 * IIFE with document-level event delegation (matches cs-clip-coupon.js pattern).
 * Morph-safe: listener on document, never lost when Horizon re-renders section HTML.
 */
(function() {
  if (window._csSummaryRemoveInit) return;
  window._csSummaryRemoveInit = true;

  /* ── Discount removal via document-level click delegation ── */
  document.addEventListener('click', async function(e) {
    const btn = e.target.closest('[data-remove-discount]');
    if (!btn || btn.disabled) return;

    const codeToRemove = btn.getAttribute('data-remove-discount');
    if (!codeToRemove) return;

    btn.disabled = true;

    /* Read remaining codes from DOM remove buttons (not /cart.js) */
    const remaining = [];
    const allBtns = document.querySelectorAll('[data-remove-discount]');
    for (const el of allBtns) {
      const c = el.getAttribute('data-remove-discount');
      if (c && c !== codeToRemove && remaining.indexOf(c) === -1) {
        remaining.push(c);
      }
    }

    const cartUpdateUrl = (typeof Theme !== 'undefined' && Theme.routes)
      ? Theme.routes.cart_update_url
      : '/cart/update.js';

    try {
      const res = await fetch(cartUpdateUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: remaining.join(',') })
      });
      const data = await res.json();
      if (data.status) {
        btn.disabled = false;
        return;
      }
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: null,
          sourceId: 'cs-cart-summary',
          data: { source: 'cs-cart-summary', itemCount: data.item_count || 0 }
        }
      }));
    } catch (err) {
      console.warn('CS summary: discount remove failed', err && err.message || '');
      btn.disabled = false;
      const errEl = document.querySelector('[data-cs-summary-error]');
      if (errEl) {
        errEl.textContent = 'Could not remove discount. Please try again.';
        errEl.style.display = 'block';
        setTimeout(function() { errEl.style.display = 'none'; }, 5000);
      }
    }
  });

  /* ── Restore <details> open state after morph re-render ── */
  try {
    if (sessionStorage.getItem('cs-summary-open') === '1') {
      const d = document.querySelector('details.cs-cart-summary');
      if (d) d.open = true;
    }
  } catch(e) {}

  /* MutationObserver watches .cs-cart-footer for morph DOM replacement */
  const footer = document.querySelector('.cs-cart-footer');
  if (footer) {
    new MutationObserver(function() {
      try {
        if (sessionStorage.getItem('cs-summary-open') === '1') {
          const d = footer.querySelector('details.cs-cart-summary');
          if (d && !d.open) d.open = true;
        }
      } catch(e) {}
    }).observe(footer, { childList: true, subtree: true });
  }
})();
